import { nanoid } from "nanoid";
import { LambdaHeaderKeys } from "@moodys/mdc-toolbox.back-end.aws.lambda.header-types";
export const addAwsHeaderInterceptor = (instance) => {
    instance.interceptors.request.use((config) => {
        const traceId = generateTraceId();
        const customHeaders = { ...config.headers };
        customHeaders[LambdaHeaderKeys.CORRELATION_ID] = nanoid();
        customHeaders["X-Amzn-Trace-Id"] = `Root=${traceId};`;
        return {
            ...config,
            headers: customHeaders,
        };
    });
};
export const buildAwsRequestHeaders = () => {
    const id = nanoid();
    return {
        [LambdaHeaderKeys.CORRELATION_ID]: id,
        "X-Amzn-Trace-Id": `Root=${generateTraceId()};`,
    };
};
/**
 * Amazon Trace ID Format (for x-ray)
 *
 * A trace_id consists of three numbers separated by hyphens. For example, 1-58406520-a006649127e371903a2de979. This includes:
 *
 * - The version number, that is, 1.
 * - The time of the original request, in Unix epoch time, in 8 hexadecimal digits.
 *    (e.g) 10:00AM December 1st, 2016 PST in epoch time is 1480615200 seconds, or 58406520 in hexadecimal digits.
 * - A 96-bit identifier for the trace, globally unique, in 24 hexadecimal digits.
 *
 * @see {@link https://docs.aws.amazon.com/xray/latest/devguide/xray-api-sendingdata.html} AWS Trace ID Documentation
 */
export const generateTraceId = () => {
    const timeStamp = Math.round(new Date().getTime() / 1000);
    const hexTime = timeStamp.toString(16);
    return `1-${hexTime}-${genRanHex(24)}`;
};
const genRanHex = (size) => [...Array(size)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join("");
//# sourceMappingURL=awsHeaders.js.map